import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import S from "./ContactInfoCard.styled";

type Props = {
  contactInfo: {
    image: any;
    title: string;
    jobTitle: string;
    mail: string;
    mobile: string;
    name: string;
    text?: string;
  };
};

const ContactInfoCard = ({ contactInfo }: Props) => {
  const { image, title, jobTitle, mail, mobile, name, text } = contactInfo;

  return (
    <>
      {title && <S.Title>{title}</S.Title>}

      <S.Container>
        {image && (
          <S.Wrapper>
            <GatsbyImage className="gatsby-image" image={image} alt={title} />
          </S.Wrapper>
        )}
        <S.Wrapper>
          {name && <S.Name>{name}</S.Name>}
          <S.Ul>
            {jobTitle && (
              <S.Li>
                <S.LiTitle>Titel: </S.LiTitle>
                <S.LiContent>{jobTitle}</S.LiContent>
              </S.Li>
            )}
            {mobile && (
              <S.Li>
                <S.LiTitle>Mobil: </S.LiTitle>
                <S.LiContent>{mobile}</S.LiContent>
              </S.Li>
            )}
            {mail && (
              <S.Li>
                <S.LiTitle>Mail: </S.LiTitle>
                <S.LiContent>
                  <a href={`mailto:${mail}`}>{mail}</a>
                </S.LiContent>
              </S.Li>
            )}
          </S.Ul>
        </S.Wrapper>
      </S.Container>
      {text && <S.Text>{text}</S.Text>}
      {!text && <S.Text />}
    </>
  );
};

export default ContactInfoCard;
